import React, { useEffect } from 'react'
import TabsMethods from './tabs.local.methods'
import { grid, item } from '../../theme'
import { cn } from 'ethcss'
import styles from './tabs.jcss'
import type { TabsDefaultProps, TabsProps } from './tabs.types'

const Tabs = (p_: TabsProps) => {
    const { active, tabs, onClick, getTabFromId } = TabsMethods(p_)

    useEffect(() => {
        if (p_.onBroadcast && active === 'areaSettings') {
            p_.onBroadcast()
        }
    }, [active])

    return (
        <div className={cn(styles.fullContent, p_.wrapperClassName)}>
            <div className={grid.row}>
                {!p_.tabsIsHidden &&
                    tabs.map((tab, index) => (
                        <div
                            key={index}
                            className={cn(
                                styles.tab,
                                {
                                    [styles.tabActive]: !p_.newDesign && active === tab.props.tabid,
                                    [styles.tabActiveNewDesign]: p_.newDesign && active === tab.props.tabid,
                                    [styles.tabNewDesign]: p_.newDesign,
                                    [item.disableWrapper]: tab.props.disabled,
                                },
                                p_.tabWrapper
                            )}
                            onClick={() => {
                                if (tab.props.disabled) {
                                    return
                                }

                                onClick(tab.props.tabid)

                                if (p_.onClickByTabId) {
                                    p_.onClickByTabId(tab.props.tabid)
                                }
                            }}
                        >
                            {tab.props.label}
                        </div>
                    ))}
            </div>
            <div className={cn(p_.className, grid.space)}>{getTabFromId(active)}</div>
        </div>
    )
}

const defaultProps: TabsDefaultProps = {
    onChange: () => {},
    className: grid.p_md,
    tabsIsHidden: false,
}

Tabs.defaultProps = defaultProps

export default Tabs
